var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect, useCallback } from 'react';
import { useToggle } from 'react-use';
import { Profile2UserOutline, EyeSlashOutline } from '../../../../../../../../components/Icon';
import Select from '../../../../../../../../components/Select';
import Modal from '../../../../../../../../components/Modal';
import { Menu } from '../styled';
import { useApi } from './useApi';
export var useHijackUser = function (canHijackUser) {
    var _a = __read(useToggle(false), 2), userModalVisible = _a[0], toggleUserModalVisible = _a[1];
    var _b = __read(useState(), 2), selectedUser = _b[0], setSelectedUser = _b[1];
    var _c = __read(useState(), 2), capturedUser = _c[0], setCapturedUser = _c[1];
    var _d = __read(useState(), 2), capturingUser = _d[0], setCapturingUser = _d[1];
    var _e = __read(useState(false), 2), captureInfoLoaded = _e[0], setCaptureInfoLoaded = _e[1];
    var _f = useApi(), getCaptureInfo = _f.getCaptureInfo, getUserInfo = _f.getUserInfo, captureUser = _f.captureUser, uncaptureUser = _f.uncaptureUser;
    useEffect(function () {
        if (!canHijackUser)
            return;
        getCaptureInfo().then(function (captureInfo) {
            setCaptureInfoLoaded(true);
            if (captureInfo.isHijacked) {
                getUserInfo(captureInfo.hijacker.pk).then(function (user) {
                    setCapturingUser({
                        id: user.id,
                        name: user.name || user.lastName + " " + user.firstName,
                    });
                });
                getUserInfo(captureInfo.hijacked.pk).then(function (user) {
                    setCapturedUser({
                        id: user.id,
                        name: user.name || user.lastName + " " + user.firstName,
                    });
                });
            }
        });
    }, [canHijackUser, getCaptureInfo, getUserInfo]);
    var handleSelectUser = function (value, option) {
        setSelectedUser(option);
    };
    var handleCaptureUser = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedUser)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, captureUser(selectedUser.value)];
                case 2:
                    _a.sent();
                    setCapturedUser({ id: selectedUser.value, name: selectedUser.label });
                    toggleUserModalVisible();
                    window.location.reload();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setCapturedUser(undefined);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [captureUser, selectedUser, toggleUserModalVisible]);
    var handleResetUser = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, uncaptureUser()];
                case 1:
                    _a.sent();
                    window.location.reload();
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [uncaptureUser]);
    var handleClickCapture = function () {
        if (capturedUser)
            handleResetUser();
        else
            toggleUserModalVisible();
    };
    var captureMenuItem = captureInfoLoaded ? (React.createElement(Menu.Item, { icon: capturedUser ? React.createElement(EyeSlashOutline, null) : React.createElement(Profile2UserOutline, null), onClick: handleClickCapture }, capturedUser ? capturedUser.name : 'Зайти под пользователем')) : (React.createElement(React.Fragment, null));
    var userSelectModal = (React.createElement(Modal, { visible: userModalVisible, title: '\u0412\u044B\u0431\u043E\u0440 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0433\u043E \u0432\u0438\u0434\u0430', okText: '\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C', onOk: handleCaptureUser, onCancel: toggleUserModalVisible, okButtonProps: {
            disabled: !selectedUser,
        } },
        React.createElement(Select, { label: '\u041F\u043E\u0438\u0441\u043A \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430', fullWidth: true, placeholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F', apiUrl: '/users/', onSelect: handleSelectUser, showSearch: true })));
    return {
        captureMenuItem: captureMenuItem,
        userSelectModal: userSelectModal,
        capturingUser: capturingUser,
    };
};
//# sourceMappingURL=useHijackUser.js.map